import { logger } from '../logger';
import { analyticsService } from './analyticsService';
import { sessionTracker } from './sessionTracker';

/**
 * Initialise les services d'analytics
 * Cette fonction est appelée au démarrage de l'application
 */
export async function initAnalytics(): Promise<void> {
  try {
    logger.debug('Initialisation des services d\'analytics', {
      category: 'Analytics',
      data: { timestamp: new Date().toISOString() }
    });

    // Configurer le niveau d'analytics en fonction de l'environnement
    const analyticsLevel = import.meta.env.VITE_ANALYTICS_LEVEL || 'essential';
    analyticsService.setAnalyticsLevel(analyticsLevel);

    // Activer ou désactiver l'analytics en fonction de la configuration
    const enableAnalytics = import.meta.env.VITE_ENABLE_ANALYTICS === 'true';
    if (enableAnalytics) {
      analyticsService.enableAnalytics();
    } else {
      analyticsService.disableAnalytics();
    }

    // Le sessionTracker s'initialise automatiquement lors de son premier accès
    // Pas besoin d'appeler une méthode init() explicitement

    logger.info('Service d\'analytics initialisé avec succès', {
      category: 'Analytics',
      data: { 
        timestamp: new Date().toISOString(),
        analyticsLevel,
        enabled: enableAnalytics
      }
    });

    return Promise.resolve();
  } catch (error) {
    logger.error('Erreur lors de l\'initialisation du service d\'analytics', {
      category: 'Analytics',
      data: { error }
    });
    return Promise.reject(error);
  }
}